import { useScreenTitle } from '../Shell/ShellScreenTitle';

function UserProfileInfo() {
  //TODO: Get account info
  //TODO: Display all account info, including supporting multiple organizations

  useScreenTitle('My Profile');

  return <h1>My Profile</h1>;
}

export { UserProfileInfo };
